import { render, staticRenderFns } from "./LoginPersonalizeDetailPage.vue?vue&type=template&id=6180b31e&scoped=true"
import script from "./LoginPersonalizeDetailPage.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizeDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180b31e",
  null
  
)

export default component.exports